@if (!item()!.hidden) {
  <li
    data-username="able-pro dashboard dashboard"
    class="nav-item coded-hasmenu"
    [routerLinkActive]="['active']"
    [ngClass]="item().groupClasses"
  >
    <a [routerLinkActive]="['active']" class="nav-link arrow-edge" (mouseenter)="navCollapse($event)">
      @if (item().icon) {
        <span class="coded-micon">
          <i class="{{ item().icon }}"></i>
        </span>
      }
      <span class="coded-mtext" style="color: red">{{ item().title }}</span>
    </a>
    <ul class="coded-submenu" [routerLinkActive]="['active']" [ngClass]="item().classes!">
      @for (item of item().children; track item) {
        @if (item.type === 'item') {
          <app-menu-item [item]="item"></app-menu-item>
        } @else if (item.type === 'collapse') {
          <app-menu-collapse [item]="item"></app-menu-collapse>
        }
      }
    </ul>
  </li>
}
